import styled from '@emotion/styled';

const ChartWrapper = styled('div')({
  position: 'relative',
  margin: '0 24px',
  padding: '40px 0',
});

export default ChartWrapper;
